import { addDoc, collection, getDocs, limit, query, where } from "firebase/firestore";
import { firebaseDB } from "../../firebase";
import { CreateBudgetGroupInviteProps } from "../../types/budgethelper";
import { Timestamp } from "firebase/firestore";

export const useCreateInvite = () => {
  const inviteCollectionRef = collection(firebaseDB, "invites");
  const userCollectionRef = collection(firebaseDB, "users");
  const createInvite = async (inviteProps: CreateBudgetGroupInviteProps) => {
    console.log(`Sending invite to ${JSON.stringify(inviteProps)}`);
    const { budgetGroup, currentUser, invitedEmail } = inviteProps;
    const invitedUserQuery = query(
      userCollectionRef,
      where("email", "==", invitedEmail),
      limit(1)
    );
    const invitedUserSnapshot = await getDocs(invitedUserQuery);
    const invitedUser = invitedUserSnapshot.docs[0]?.data();
    
    const invite = {
      groupId: budgetGroup.id,
      groupName: budgetGroup.friendlyName,
      invitedBy: currentUser.friendlyName,
      invitedUserId: invitedUser?.userId, 
      timestamp: Timestamp.now()
    };
    await addDoc(inviteCollectionRef, invite);
  };
  return { createInvite };
};